import {useTranslation} from 'react-i18next';
import {OrderInPaperworkType} from '../../../types/TypesDepotPaperwork';
import {toast} from 'react-toastify';
import TableButtonsActions, {
	ActionConfig,
} from '../../../Components/TableButtonsActions/TableButtonsActions';
import edit from '../../../assets/img/icons/paperworkList/el_pencil-alt.svg';
import print from '../../../assets/img/icons/paperworkList/fluent_print-28-filled.svg';
import close from '../../../assets/img/icons/paperworkList/gridicons_cross-circle.svg';
import {useDeleteActivitiesMutation} from '../../../redux/activitiesApi';
import style from '../PaperworkList.module.css';

import {useNavigate} from 'react-router-dom';
import {handleApiCall} from '../../../assets/utils/utils';

const PaperworkTableActions = ({
	order,
}: {
	order: OrderInPaperworkType;
	onDeleteOrder?: (orderId: string) => void;
}) => {
	const {t} = useTranslation();
	const navigate = useNavigate();
	const [deleteOrder] = useDeleteActivitiesMutation();

	const handlers = {
		delete: async (id: number) => {
			await handleApiCall({
				apiCall: () => deleteOrder(id),
				onSuccess: (data) => toast.success(data?.message.textmsg ?? ''),
			});
		},
		edit: (id: number) => {
			navigate(`/creation_of_design/${id}`);
		},
		print: (id: number) => {
			navigate(`/paperwork-print/${id}`);
		},
	};

	const actions: ActionConfig[] = [
		{
			type: 'delete',
			icon: close,
			label: t('Видалити'),
			requiresConfirmation: true,
			confirmText: t('Ви дійсно хочете видалити замовлення?'),
			disabled: (status) => !(status === 'created' || status === 'confirmed'),
			handler: handlers.delete,
		},
		{
			type: 'edit',
			icon: edit,
			label: t('Редагувати'),
			disabled: (status) => !(status === 'created' || status === 'confirmed'),
			handler: handlers.edit,
		},
		{
			type: 'print',
			icon: print,
			label: t('Друк'),
			disabled: () => false,
			handler: handlers.print,
		},
	];
	return (
		<>
			<div className={style.tableColumn}>
				<TableButtonsActions
					actions={actions}
					orderId={+order.id}
					orderStatus={order.status}
				/>
			</div>
		</>
	);
};

export default PaperworkTableActions;
